function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.872 2.974C3.872 1.884 4.756 1 5.846 1h4.308c1.09 0 1.974.884 1.974 1.974v2.334h.898c1.09 0 1.974.884 1.974 1.974v2.872c0 1.09-.884 1.974-1.974 1.974h-.898v.898c0 1.09-.884 1.974-1.974 1.974H5.846a1.974 1.974 0 01-1.974-1.974v-.898h-.898A1.974 1.974 0 011 10.154V7.282c0-1.09.884-1.974 1.974-1.974h.898V2.974zm1.077 2.334h6.102V2.974a.897.897 0 00-.897-.897H5.846a.897.897 0 00-.897.897v2.334zM2.974 6.385a.897.897 0 00-.897.897v2.872c0 .495.402.897.897.897h.898v-.897c0-1.09.884-1.975 1.974-1.975h4.308c1.09 0 1.974.884 1.974 1.975v.897h.898a.897.897 0 00.897-.897V7.282a.897.897 0 00-.897-.897H2.974zm8.077 3.769a.897.897 0 00-.897-.898H5.846a.897.897 0 00-.897.898v2.872c0 .495.402.897.897.897h4.308a.897.897 0 00.897-.897v-2.872z",
  fill: "#2D2D2D"
});
function SvgImpresora(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Impresora.svg";
export { SvgImpresora as ReactComponent };